import React, { FC, ReactNode } from "react"
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  styled,
} from "@mui/material"
interface DialogBoxProps {
  title: string
  content: ReactNode
  actions: ReactNode
  open: boolean
  titleStyle?: object
  actionStyle?: object
  zIndex?: number
}
const CustomDialogBox = styled(Dialog, {
  shouldForwardProp: (prop) => prop !== "customZIndex"
})<{ customZIndex?: number }>(({ theme, customZIndex }) => ({
  ...(customZIndex && {
    zIndex: customZIndex,
    "& .MuiBackdrop-root": {
      zIndex: customZIndex - 1,
    },
  }),
  "& .MuiDialog-paper": {
    width: "444px",
    ...(customZIndex && {
      zIndex: customZIndex,
    }),
  },
  "& .MuiDialogTitle-root": {
    // color: "#fff",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 500,
    letterSpacing: "0.15px",
  },
  //   "& .MuiDialogContent-root": {
  //     padding: 0,
  //     marginTop: "30px",
  //     letterSpacing: "-0.5px",
  //     position: "relative",
  //     fontWeight: "normal",
  //   },
}))

const DialogBox: FC<DialogBoxProps> = ({
  open,
  title,
  content,
  actions,
  titleStyle = {},
  actionStyle = {},
  zIndex,
}) => {
  return (
    <>
      <CustomDialogBox
        open={open}
        customZIndex={zIndex}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle sx={{ ...titleStyle }}>{title}</DialogTitle>
        <DialogContent>{content}</DialogContent>
        <DialogActions sx={{ ...actionStyle }}>{actions}</DialogActions>
      </CustomDialogBox>
    </>
  )
}

export default DialogBox
